import { render, staticRenderFns } from "./ord.vue?vue&type=template&id=106565ae&"
import script from "./ord.vue?vue&type=script&lang=ts&"
export * from "./ord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ord.vue"
export default component.exports